import "./index.css";
import React from "react";
import { withRouter } from "react-router";
import { Button } from "antd";
import AuthTokenHolder from "@/services/http/AuthTokenHolder";

function getWechatIframeUrl(name: string) {
  const search = new URLSearchParams();

  const callbackUrl = "https://share.fahuoyi.com/WeChat/management/add/finish";

  search.set("redirect_uri", "https://main.fahuoyi.com/wechat/login");

  search.set("appid", "wxb4e0d35c482273be");
  search.set("response_type", "code");
  search.set("scope", "snsapi_login");
  search.set("connect_redirect", "1");
  search.set("state", `ES_ADD_SUB_USER_${name}_${AuthTokenHolder.getToken()}_${callbackUrl}`);
  search.set("style", "black");

  return `https://open.weixin.qq.com/connect/qrconnect?${search.toString()}#wechat_redirect`;
}

function ScanCode(props) {
  const handleBack = () => {
    props.history.goBack();
  };

  return (
    <div className="scan-code-body">
      <span className="title">正在为{props.name}绑定微信</span>
      <div id="code-container">
        <iframe
          src={getWechatIframeUrl(props.name)}
          scrolling="no"
          width="300px"
          height="400px"
          style={{ border: 0 }}
          sandbox="allow-scripts allow-popups allow-top-navigation allow-top-navigation-by-user-activation allow-same-origin"
        ></iframe>
      </div>
      <Button type="default" onClick={handleBack}>
        上一步
      </Button>
    </div>
  );
}

export default withRouter(ScanCode);
